import React, { useState } from "react";

import { faLock } from "@performyard/fontawesome/pro-solid-svg-icons";
import { ButtonStandard } from "@performyard/py-components";

import { AIPromotionModal } from "./AIPromotionModal";

type AIPromotionalButtonProps = {
	label: string;
	promotionId: string;
	userEmail: string;
	buttonSize?: "small" | "medium";
};

export const AIPromotionalButton = ({
	label,
	promotionId,
	userEmail,
	buttonSize = "small",
}: AIPromotionalButtonProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<div>
			<ButtonStandard
				onClick={() => setIsModalOpen(true)}
				color="primary"
				size={buttonSize}
				iconLeft={faLock}
				data-testid="ai-promotional-button"
			>
				{label}
			</ButtonStandard>
			<AIPromotionModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				promotionId={promotionId}
				userEmail={userEmail}
			/>
		</div>
	);
};
